/**
 * @mixin Actions mixin.
 */
export default {
    props: {
        /**
         * Array of actions to display in menu {color: '', event: '', icon: '', title: ''}.
         */
        menuActions: {
            type: Array,
            default: () => [
                {
                    color: 'info',
                    event: 'edit',
                    icon: 'edit',
                    title: 'Edit'
                },
                {
                    color: 'error',
                    event: 'remove',
                    icon: 'delete',
                    title: 'Remove'
                }
            ]
        },
    },
    computed: {
        actionEvents () {
            return {
                select: this.emitAction
            }
        }
    },
    methods: {
        emitAction (action) {
            /**
             * Action event.
             * @type {object}
             */
            this.$emit('select', action)
        }
    }
}
